module.exports = __webpack_public_path__ + "img/logo.f8667d6d.jpg";